/* MP Doors delivery method selector — pickup / customer-arranged carrier only */
(function () {
  'use strict';

  if (window.__MPQ_DELIVERY_METHODS_V2__) return;
  window.__MPQ_DELIVERY_METHODS_V2__ = true;

  var STORAGE_KEY = 'MPQ_DELIVERY_METHOD_V1';
  var METHODS = {
    PICKUP: 'CUSTOMER_PICKUP',
    CARRIER: 'CUSTOMER_CARRIER'
  };

  var LABELS = {};
  LABELS[METHODS.PICKUP] = 'Customer Pickup';
  LABELS[METHODS.CARRIER] = 'Customer-Arranged Carrier';

  var OBSOLETE_LOCAL_KEYS = [
    'MPQ_ACTIVE_FREIGHT_REQUEST_DEV_V1',
    'MPQ_FREIGHT_CART_CHANGED_NOTICE_DEV_V1',
    'MPQ_FREIGHT_EXPORT_CONTEXT_V1',
    'MPQ_FREIGHT_EXPORT_INVALID_NOTICE_V1',
    'ND_CONFIRMED_TRUCK_FREIGHT_V1'
  ];

  var OBSOLETE_CART_ATTRIBUTES = [
    'Freight Request ID',
    'Freight Quote Snapshot',
    'Freight Quote Status',
    'Freight Carrier',
    'Freight Service Type',
    'Freight Transit Time',
    'Freight Valid Until',
    'Accepted Freight Amount Cents'
  ];

  var syncing = false;
  var observerTimer = null;

  function isCartPage() {
    return /\/cart(?:\/|$|\?)/i.test(location.pathname + location.search);
  }

  function isAllowed(method) {
    return method === METHODS.PICKUP || method === METHODS.CARRIER;
  }

  function readStoredMethod() {
    try {
      var value = String(localStorage.getItem(STORAGE_KEY) || '').trim();
      return isAllowed(value) ? value : '';
    } catch (error) {
      return '';
    }
  }

  function saveStoredMethod(method) {
    try {
      if (isAllowed(method)) {
        localStorage.setItem(STORAGE_KEY, method);
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch (error) {}
  }

  function clearObsoleteLocalState() {
    try {
      var current = String(localStorage.getItem(STORAGE_KEY) || '').trim();
      if (!isAllowed(current)) localStorage.removeItem(STORAGE_KEY);

      OBSOLETE_LOCAL_KEYS.forEach(function (key) {
        localStorage.removeItem(key);
      });
    } catch (error) {}
  }

  function methodFromLabel(value) {
    var normalized = String(value || '').trim().toLowerCase();
    if (normalized === 'customer pickup') return METHODS.PICKUP;
    if (
      normalized === 'customer-arranged carrier' ||
      normalized === 'customer arranged carrier'
    ) {
      return METHODS.CARRIER;
    }
    return '';
  }

  async function fetchCart() {
    var response = await fetch('/cart.js?_=' + Date.now(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache'
      }
    });

    if (!response.ok) throw new Error('Unable to read the current cart.');
    return response.json();
  }

  async function syncCartAttributes(method) {
    if (syncing) return;
    syncing = true;

    try {
      var attributes = {};
      attributes['Delivery Method'] = isAllowed(method) ? LABELS[method] : '';

      OBSOLETE_CART_ATTRIBUTES.forEach(function (key) {
        attributes[key] = '';
      });

      var response = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ attributes: attributes })
      });

      if (!response.ok) throw new Error('Unable to save the selected delivery method.');
    } finally {
      syncing = false;
    }
  }

  function injectStyles() {
    if (document.getElementById('mpq-delivery-method-style')) return;

    var style = document.createElement('style');
    style.id = 'mpq-delivery-method-style';
    style.textContent = `
      .cart__footer { flex-wrap: wrap; }
      #mpq-delivery-method-card {
        flex: 0 0 100%; width: 100%; box-sizing: border-box;
        margin: 0 0 26px; padding: 20px;
        border: 1px solid #d8ddd9; border-radius: 10px;
        background: #fff; box-shadow: 0 4px 16px rgba(26,39,32,.06);
      }
      #mpq-delivery-method-card * { box-sizing: border-box; }
      .mpq-dm-header {
        display: flex; align-items: flex-start; justify-content: space-between;
        gap: 14px; margin-bottom: 16px;
      }
      .mpq-dm-title { margin: 0; color: #26352f; font-size: 18px; line-height: 1.25; font-weight: 750; }
      .mpq-dm-intro { margin: 5px 0 0; color: #667069; font-size: 13px; line-height: 1.5; }
      .mpq-dm-required {
        flex: 0 0 auto; padding: 5px 9px; border-radius: 999px;
        background: #f1f3f1; color: #566159; font-size: 11px; font-weight: 700;
      }
      .mpq-dm-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
      .mpq-dm-option {
        min-height: 190px; display: flex; flex-direction: column; padding: 16px;
        border: 1px solid #d9dedb; border-radius: 8px; background: #fff;
        transition: border-color .16s ease, box-shadow .16s ease, background .16s ease;
      }
      .mpq-dm-option:hover { border-color: #98a49d; box-shadow: 0 3px 12px rgba(31,41,36,.08); }
      .mpq-dm-option.is-selected {
        border-color: #26352f; background: #f8faf8; box-shadow: 0 0 0 2px rgba(38,53,47,.10);
      }
      .mpq-dm-radio-row { display: flex; align-items: flex-start; gap: 10px; }
      .mpq-dm-radio-row input {
        width: 17px; height: 17px; margin: 2px 0 0; accent-color: #26352f; cursor: pointer;
      }
      .mpq-dm-option-title { color: #26352f; font-size: 14px; line-height: 1.35; font-weight: 750; }
      .mpq-dm-copy { margin: 11px 0 14px 27px; color: #657068; font-size: 12.5px; line-height: 1.55; }
      .mpq-dm-action {
        width: 100%; min-height: 40px; margin-top: auto; border: 1px solid #26352f;
        border-radius: 6px; background: #26352f; color: #fff;
        font: inherit; font-size: 12px; font-weight: 750; cursor: pointer;
      }
      .mpq-dm-action:hover { filter: brightness(.95); }
      .mpq-dm-action.is-selected { background: #fff; color: #26352f; }
      .mpq-dm-status {
        display: none; margin-top: 14px; padding: 12px 14px;
        border: 1px solid #d9dedb; border-radius: 7px;
        background: #f8faf8; color: #3d4942; font-size: 12.5px; line-height: 1.55;
      }
      .mpq-dm-status.is-visible { display: block; }
      .mpq-dm-status strong { color: #26352f; }
      @media (max-width: 749px) {
        #mpq-delivery-method-card { padding: 16px; }
        .mpq-dm-grid { grid-template-columns: 1fr; }
        .mpq-dm-option { min-height: 170px; }
      }
    `;
    document.head.appendChild(style);
  }

  function optionHtml(value, title, copy, buttonText) {
    return `
      <div class="mpq-dm-option" data-method="${value}">
        <label class="mpq-dm-radio-row">
          <input type="radio" name="mpq-delivery-method" value="${value}">
          <span class="mpq-dm-option-title">${title}</span>
        </label>
        <div class="mpq-dm-copy">${copy}</div>
        <button type="button" class="mpq-dm-action" data-select-method="${value}" data-original-label="${buttonText}">
          ${buttonText}
        </button>
      </div>
    `;
  }

  function buildCard() {
    var card = document.createElement('section');
    card.id = 'mpq-delivery-method-card';
    card.setAttribute('aria-labelledby', 'mpq-delivery-method-heading');
    card.innerHTML = `
      <div class="mpq-dm-header">
        <div>
          <h2 id="mpq-delivery-method-heading" class="mpq-dm-title">Delivery Method</h2>
          <p class="mpq-dm-intro">Choose how you would like to receive your order before exporting the quote.</p>
        </div>
        <span class="mpq-dm-required">Required</span>
      </div>
      <div class="mpq-dm-grid">
        ${optionHtml(
          METHODS.PICKUP,
          '1. Customer Pickup',
          'I will arrange pickup from MP Doors. Freight charges will not be included in this quotation.',
          'Continue with Customer Pickup'
        )}
        ${optionHtml(
          METHODS.CARRIER,
          '2. Customer-Arranged Carrier',
          'I will arrange my own freight carrier. Freight charges will not be included in this quotation.',
          'Use My Own Carrier'
        )}
      </div>
      <div id="mpq-delivery-method-status" class="mpq-dm-status" aria-live="polite"></div>
    `;
    return card;
  }

  function findInsertTarget() {
    var noteBox =
      document.querySelector('textarea[name="note"]') ||
      document.querySelector('#Cart-note') ||
      document.querySelector('textarea[id*="Cart-note"]');

    if (!noteBox) return null;
    return noteBox.closest('cart-note') || noteBox.closest('.cart__note') || noteBox.parentElement;
  }

  function injectCard() {
    if (document.getElementById('mpq-delivery-method-card')) return;
    var target = findInsertTarget();
    if (!target || !target.parentElement) return;
    target.parentElement.insertBefore(buildCard(), target);
  }

  function setExportEnabled(enabled) {
    var button = document.getElementById('nd-btn-export');
    if (!button) return;

    button.disabled = !enabled;
    button.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    button.title = enabled ? '' : 'Select a delivery method before exporting your quote.';
  }

  function renderSelection(method) {
    var card = document.getElementById('mpq-delivery-method-card');
    if (!card) return;

    method = isAllowed(method) ? method : '';

    card.querySelectorAll('.mpq-dm-option').forEach(function (option) {
      var optionMethod = option.getAttribute('data-method');
      var selected = optionMethod === method;
      option.classList.toggle('is-selected', selected);

      var radio = option.querySelector('input[type="radio"]');
      if (radio) radio.checked = selected;

      var button = option.querySelector('.mpq-dm-action');
      if (button) {
        button.classList.toggle('is-selected', selected);
        button.textContent = selected ? 'Selected' : button.getAttribute('data-original-label');
      }
    });

    var status = document.getElementById('mpq-delivery-method-status');
    if (status) {
      var message = '';
      if (method === METHODS.PICKUP) {
        message = '<strong>Customer Pickup selected.</strong> Freight charges will not be included in this quotation.';
      } else if (method === METHODS.CARRIER) {
        message = '<strong>Customer-Arranged Carrier selected.</strong> Freight charges will not be included in this quotation.';
      }

      status.innerHTML = message;
      status.classList.toggle('is-visible', Boolean(message));
    }

    setExportEnabled(Boolean(method));
  }

  async function selectMethod(method) {
    if (!isAllowed(method)) return;

    saveStoredMethod(method);
    renderSelection(method);

    try {
      await syncCartAttributes(method);
    } catch (error) {
      console.error('[MPQ Delivery Method]', error);
      window.alert('The delivery method was selected, but it could not be saved to the cart. Please try again.');
      return;
    }

    try {
      window.dispatchEvent(
        new CustomEvent('mpq:delivery-method-changed', {
          detail: { method: method, label: LABELS[method] }
        })
      );
    } catch (error) {}
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var optionButton = target.closest('[data-select-method]');
      if (optionButton) {
        event.preventDefault();
        selectMethod(optionButton.getAttribute('data-select-method'));
        return;
      }

      var exportButton = target.closest('#nd-btn-export');
      if (exportButton && !readStoredMethod()) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        window.alert('Please select Customer Pickup or Customer-Arranged Carrier before exporting your quote.');
      }
    }, true);

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var radio = target.closest('input[name="mpq-delivery-method"]');
      if (radio) selectMethod(radio.value);
    });

    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY) renderSelection(readStoredMethod());
    });

    window.addEventListener('mpq:delivery-method-reset', function () {
      renderSelection(readStoredMethod());
    });
  }

  async function hydrateFromCart() {
    try {
      var cart = await fetchCart();
      var cartLabel = cart && cart.attributes ? cart.attributes['Delivery Method'] : '';
      var cartMethod = methodFromLabel(cartLabel);
      var storedMethod = readStoredMethod();

      if (!storedMethod && cartMethod) {
        saveStoredMethod(cartMethod);
        storedMethod = cartMethod;
      }

      renderSelection(storedMethod);
      await syncCartAttributes(storedMethod);
    } catch (error) {
      console.warn('[MPQ Delivery Method] Cart hydration failed:', error);
    }
  }

  function mount() {
    injectStyles();
    injectCard();
    renderSelection(readStoredMethod());
  }

  function observeDynamicCartUi() {
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        var node = mutation.target && mutation.target.nodeType === 1
          ? mutation.target
          : mutation.target && mutation.target.parentElement;
        return !(node && node.closest && node.closest('#mpq-delivery-method-card'));
      });

      if (!relevant) return;
      clearTimeout(observerTimer);
      observerTimer = setTimeout(mount, 120);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    if (!isCartPage()) return;
    clearObsoleteLocalState();
    bindEvents();
    mount();
    hydrateFromCart();
    observeDynamicCartUi();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
